import dynamic from "next/dynamic";

export * from "./buyCryptoReducer";
export const BuyCryptoDialog = dynamic(() =>
    import("./BuyCryptoDialog").then((module) => module.BuyCryptoDialog),
);
